<app-sidenav>
    <app-router-outlet></app-router-outlet>
</app-sidenav>